import { CompanyDashboard } from "modules/companyAdmin";

const CompanyAdminDashboardPage = () => <CompanyDashboard />;

export default CompanyAdminDashboardPage;
